import { jsx } from "react/jsx-runtime";
import { ContentType } from "../../../enums/contentStack.js";
import { findOneBusinessEntry, DEFAULT_FIELD_EXCEPTIONS } from "../../../services/content/business.lib.js";
import { Skeleton } from "@nxt-costco-com/forge-components";
import { Analytics } from "../../Analytics/index.js";
import { VIEW_NAME_SKELETON, COMPONENT_NAME } from "./constants.js";
import { CalloutCard } from "./view.callout.js";
import { FeaturesCard } from "./view.features.js";
import { MAX_TILE_WIDTH } from "./styles.js";
function FeatureHighlightCardUI({
  data,
  isLoading = false
}) {
  if (isLoading) {
    return /* @__PURE__ */ jsx(
      Skeleton,
      {
        "data-testid": VIEW_NAME_SKELETON,
        height: 460,
        variant: "rectangular",
        width: MAX_TILE_WIDTH
      }
    );
  }
  if ((data == null ? void 0 : data.hide_feature_icons) && (data == null ? void 0 : data.feature_caption)) {
    return /* @__PURE__ */ jsx(CalloutCard, { data });
  }
  return /* @__PURE__ */ jsx(FeaturesCard, { data });
}
async function FeatureHighlightCard({
  entryId,
  locale,
  enableLivePreview
}) {
  var _a, _b;
  const data = await findOneBusinessEntry(
    ContentType.FeatureHighlightCard,
    entryId,
    locale,
    DEFAULT_FIELD_EXCEPTIONS,
    enableLivePreview
  );
  if (!data) {
    return null;
  }
  return /* @__PURE__ */ jsx(
    Analytics,
    {
      analyticData: {
        adItem: {
          style: "feature highlight card",
          title: data.feature_title,
          type: "category",
          url: (_b = (_a = data.button_group) == null ? void 0 : _a.button_with_costco_url) == null ? void 0 : _b.url
        }
      },
      children: /* @__PURE__ */ jsx(FeatureHighlightCardUI, { data }, entryId)
    }
  );
}
FeatureHighlightCardUI.displayName = COMPONENT_NAME;
export {
  FeatureHighlightCard,
  FeatureHighlightCardUI
};
